import { createTheme, Palette } from '@mui/material/styles';
import { IAppTheme } from 'types/theme';
import { applyHslDiff } from './color';
import { createCommonComponentsOverrides } from './componentOverrides';
import { themeBase } from './themeBase';
import { createThemedTypographies } from './typographies';

const createLightPalette = (
	main: string,
	dark: string,
	light: string,
	highlight: string,
	contrast: string
): Palette => {
	const { palette } = createTheme({
		palette: {
			mode: 'light',
			appBackground: `linear-gradient(270deg, ${applyHslDiff(main, '#3D5AFE', '#EAF2FE', { resL: 0.96 })} 14%, ${applyHslDiff(main, '#3D5AFE', '#CDDCF8', { resL: 0.89 })} 24%, ${applyHslDiff(main, '#3D5AFE', '#B0C5EC', { resL: 0.81 })} 28%, #c4c4c4 50%)`,
			mainPaperBackground: '#FFF',
			illustrationAccent: applyHslDiff(main, '#3D5AFE', '#8C9EFF'),
			primary: {
				main,
				dark,
				light,
				highlight,
				contrastText: contrast
			},
			grey: {
				'50': '#FAFAFA',
				'100': '#F4F4F4',
				'200': '#EDEDED',
				'300': '#D7D7D7',
				'400': '#A5A5A5',
				'500': '#767676',
				'600': '#575757',
				'700': '#444444',
				'800': '#1F1F1F'
			}
		}
	});

	return palette;
};

const createStyledLightTheme = (appTheme?: IAppTheme | null) => {
	const { main, dark, light, highlight, contrast } =
		appTheme?.light?.colors?.primary || {};
	const palette = createLightPalette(
		main || '#3D5AFE',
		dark || '#1A237E',
		light || '#A0C8F8',
		highlight || '#DBEAFC',
		contrast || '#FFFFFF'
	);

	const theme = createTheme({
		assets: {
			logo: appTheme?.light.logoUrl,
			favicon: appTheme?.light.faviconUrl
		},
		...themeBase,
		typography: createThemedTypographies(appTheme?.light),
		palette,
		components: createCommonComponentsOverrides(palette)
	});

	return theme;
};

export { createStyledLightTheme };
